export default __webpack_public_path__ + "static/media/careers - vector.2bbbf838.svg";